/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ConfirmationModalComponent } from '../components/confirmation-modal/confirmation-modal.component';

@Injectable({providedIn: 'root'})
export class ConfirmationDialogService {

  private dialogOnCloseSubscription: Subscription;

  constructor(protected dialog: MatDialog) {
    console.log(`ConfirmationDialogService constructor`);
  }

  openConfirmationDialog(title: string, message: string, callback: Function, width: string = '450px') {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
        width: width,
        data: {
          title: title,
          message: message,
        },
      });
  
      if (this.dialogOnCloseSubscription) {
        this.dialogOnCloseSubscription.unsubscribe();
      }

      this.dialogOnCloseSubscription = dialogRef.componentInstance.onClose.subscribe((result) => {
        if (result.result) {
            callback();
        }

        this.dialogOnCloseSubscription.unsubscribe();
      });
  }

  openConfirmationDialogWithCancel(title: string, message: string, okCallback: Function, cancelCallback: Function, width: string = '450px') {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
        width: width,
        data: {
          title: title,
          message: message,
        },
      });
  
      if (this.dialogOnCloseSubscription) {
        this.dialogOnCloseSubscription.unsubscribe();
      }

      this.dialogOnCloseSubscription = dialogRef.componentInstance.onClose.subscribe((result) => {
        if (result.result) {
            okCallback();
        } else {
            cancelCallback();
        }

        this.dialogOnCloseSubscription.unsubscribe();
      });
  }


  openConfirmationDialogForFormLostChanges(callback: Function) {
    this.openConfirmationDialog('Confirm Lost Changes', 'Changes have been made. Closing this form will lose these changes. Are you sure you want to continue?', callback);
  }
}